// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"f4a1ceae","378":"3de62543","488":"09bd6067","839":"23b78f88"}[chunkId] + ".chunk.js";
};